module.exports = __webpack_public_path__ + "static/media/zoic-logo_sm.d7e5e6e6.png";